import { init } from '@sfvine/main';
import * as qiankun from '@sfvine/main-qiankun';
import type { PluginOptions } from './type';
import { onSensorsWebClick } from './sensors';
import { useSettingsStore } from '../stores';
import { loginSuccess } from '../stores/loginSuccess';

const options: PluginOptions = {
  onInit: () => {
    init(qiankun);

    qiankun.bus.$on('login', async () => {
      const {
        settings: { casConfig, login },
      } = useSettingsStore();
      const loginTypeRes = typeof login.type === 'function' ? await login.type() : login.type
      // const cas = new CAS(casConfig);

      // 避免 http + iframe + cas 登录的 bug
      if (window === window.parent) {
        login?.onBeforeLogin?.(loginTypeRes);
        try {
          await login?.onLogin?.(loginTypeRes, casConfig);
          loginSuccess.value = true
          login?.onLoginSuccess?.(loginTypeRes);
          qiankun.bus.$emit('loginSuccess');
        } catch (e) {
          login?.onLoginFailed?.(loginTypeRes, e);
          qiankun.bus.$emit('loginFailed', e);
        }
      } else {
        window.parent.location.reload();
      }
    });
    qiankun.bus.$on('sensors', onSensorsWebClick);
  },
};

export default options;
